module.exports = __webpack_public_path__ + "static/media/xp-investimentos-logo.511ba284.svg";